import { render } from "./UiRecaptcha.vue?vue&type=template&id=93ba5674"
import script from "./UiRecaptcha.vue?vue&type=script&lang=js"
export * from "./UiRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__